import React from "react";
import axios from "axios";
import "react-datepicker/dist/react-datepicker.css";
import * as apiMethods from "../res/apiMethods.js";

import Button from "@mui/material/Button";
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Swal from "sweetalert2";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Stack from '@mui/material/Stack';
import AccessDenied from "./accessDenied.jsx";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import LockClockIcon from "@mui/icons-material/LockClock";

const ClosedPeriods = () => {
  const [props, setProps] = React.useState({
    usersData: [],
    createDialog: false,
    update: false,
    userId: "",
    startDate: new Date(),
    endDate: new Date(),
    startDateSelected: false,
    showModalPeriod: false
  });
  
  /*
  const validationSchema = yup.object().shape({
    username: yup.string().required("El nombre de usuario es requerido"),
    contraseña: yup.string().required("La contraseña es requerida"),
    roleId: yup.string().required("El rol es requerido"),
  });
  */

  const setState = (value) => {
    setProps((prevState) => ({ ...prevState, ...value }));
  };

  const handleClosePeriod = (e) => {
    setState({ showModalPeriod: false });
  };

  const handleChangeDatePickerPayment = (date, dateTarget) => {
    if (dateTarget === "start") {
        setState({
            startDate: date,
            startDateSelected: true
        });
    } else {
        setState({
            endDate: date,
        });
    }
  };

  const block = () => {
    let watever = window.sessionStorage.getItem("localToken")
    let watever2 = JSON.parse(atob(watever.split(".")[1]))
    return watever2.roleId == 1 ? false : true
  }

  const handleShowPeriod = (e) => {
    e.preventDefault();
    setState({ showModalPeriod: true });
  };
  
  /*
  const cerrar = (body) => {

    Swal.fire({ title: "Realizando Cierre de periodo 2", allowOutsideClick: false });
    Swal.showLoading();

    axios
        .patch(apiMethods.CIERRE_PERIODO, body, {})
        .then((response) => {
          Swal.close();
          toast.success(`Cierre de periodo exitoso`);
          // window.location.reload();
          return true;
        })
        .catch((error) => {
          Swal.close();
          console.error(error);
          toast.error("Error al cerrar el periodo");
          return false;
        });
  }
  */

  const closePeriod = () =>{

    let body = {
      //fechaIni: props.startDate.getFullYear() + "/" + ("0"+(props.startDate.getMonth()+1)).slice(-2) + "/" + ("0" + props.startDate.getDate()).slice(-2),
      fechaFin: props.endDate.getFullYear() + "/" + ("0"+(props.endDate.getMonth()+1)).slice(-2) + "/" + ("0" + props.endDate.getDate()).slice(-2)
      //fechaFin:"2000/02/31"
    };

    //console.log(body.fechaIni);


    

    //Swal.fire({ title: "Realizando Cierre de periodo", allowOutsideClick: false });
    //Swal.showLoading();

    axios
        .patch(apiMethods.CIERRE_PERIODO_FECHA, body, {})
        .then((response) => {
          //Swal.close();
          toast.success(`Fechas exitosas`);
          // window.location.reload();
        })
        .catch((error) => {
          console.error(error);
          toast.error("Error de fechas");
        });

    Swal.fire({ title: "Realizando Cierre de periodo", allowOutsideClick: false });
    Swal.showLoading();

    axios
        .patch(apiMethods.CIERRE_PERIODO, body, {})
        .then((response) => {
          Swal.close();
          toast.success(`Cierre de periodo exitoso`);
          setTimeout(() => {
            //window.location.reload();
          }, 5000);
          // window.location.reload();
          return true;
        })
        .catch((error) => {
          console.error(error);
          toast.error("Error al cerrar el periodo");
          return false;
        });

        //if(cerrar(body)){Swal.close();}else{console.log("Socio no se pudo");toast.error("Nada no se pudo");};
        
  }

  /*<KeyboardDatePicker
                style={{"width":"60%"},{"marginLeft":"0.5rem"}}
                disableToolbar
                variant="inline"
                label="Fecha inicio"
                format="dd/MM/yyyy"
                disabled={true}
                autoOk
                value={props.startDate}
                onChange={date => handleChangeDatePickerPayment(date, "start")}
                maxDate={props.endDate}
            />*/

  return window.sessionStorage.getItem("localToken") ? (
    <React.Fragment>
      <ToastContainer />
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem', maxWidth: '900px', margin: '0 auto' }}>
          {/* Header de la sección */}
          <div className="section-header">
            <div className="title-group">
              <h1>Cierre de Período</h1>
              <p>Proceso de cierre contable y liquidación periódica del sistema</p>
            </div>
          </div>

          {/* Panel explicativo y de acción */}
          <div className="glass-panel" style={{ padding: '2.5rem' }}>
            <div style={{
              display: 'flex',
              alignItems: 'flex-start',
              gap: '1rem',
              background: '#FFF1F2',
              border: '1px solid #FFE4E6',
              borderRadius: '12px',
              padding: '1.25rem 1.5rem',
              marginBottom: '2rem'
            }}>
              <WarningAmberIcon sx={{ color: '#D71920', fontSize: '1.6rem', mt: '2px', flexShrink: 0 }} />
              <div>
                <h4 style={{ margin: '0 0 0.35rem 0', color: '#9F1239', fontSize: '0.98rem', fontWeight: 700 }}>
                  Acción de Cierre Contable
                </h4>
                <p style={{ margin: 0, color: '#4C0519', fontSize: '0.88rem', lineHeight: 1.55 }}>
                  El cierre de período consolida las operaciones y actualiza los saldos y estados financieros hasta la fecha de corte seleccionada. Esta acción solo puede ser ejecutada por administradores autorizados.
                </p>
              </div>
            </div>

            <div style={{ display: 'flex', justifyContent: 'center', padding: '1rem 0' }}>
              <button
                type="button"
                className="btn-mobilia-primary"
                onClick={handleShowPeriod}
                disabled={block()}
                style={{ padding: '0.75rem 2.25rem', fontSize: '0.95rem' }}
              >
                <LockClockIcon style={{ fontSize: '1.2rem' }} /> Iniciar Cierre de Período
              </button>
            </div>
          </div>
        </div>

        {/* Modal Cierre de Período */}
        <Dialog
          open={props.showModalPeriod}
          onClose={handleClosePeriod}
          fullWidth={true}
          maxWidth="xs"
          PaperProps={{
            sx: {
              borderRadius: '16px',
              boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)'
            }
          }}
        >
          <DialogTitle sx={{ fontWeight: 700, fontSize: '1.15rem', color: '#101828', pb: 1 }}>
            Cierre de Períodos
          </DialogTitle>
          <DialogContent dividers sx={{ borderColor: '#EAECF0' }}>
            <p style={{ color: '#475467', fontSize: '0.88rem', marginBottom: '1.25rem' }}>
              Por favor indique la fecha de corte para el cierre:
            </p>
            <Stack style={{ marginTop: "0.5rem" }} spacing={2}>
              <DatePicker
                label="Fecha fin"
                autoOk
                format="dd/MM/yyyy"
                value={props.endDate}
                onChange={date => handleChangeDatePickerPayment(date, "end")}
                disableFuture 
              />
            </Stack>
          </DialogContent>
          <DialogActions sx={{ padding: '1rem 1.5rem', gap: '0.5rem' }}>
            <button
              type="button"
              className="btn-mobilia-secondary"
              onClick={handleClosePeriod}
            >
              Cancelar
            </button>
            <button
              type="button"
              className="btn-mobilia-primary"
              onClick={closePeriod}
            >
              Confirmar Cierre
            </button>
          </DialogActions>
        </Dialog>
      </LocalizationProvider>
    </React.Fragment>
  ) : (
    <AccessDenied />
  );

    

};

export default ClosedPeriods;
